import type { CopyPriceRequest } from '@/api';
import { FilterMode } from '@/api';
import type { DefaultOptionType } from '@/components/combobox/combobox';

type ThemeGroupFilters = Pick<
  CopyPriceRequest,
  | 'themeIdsAsString'
  | 'themeFilterMode'
  | 'groupIdsAsString'
  | 'groupFilterMode'
>;

/**
 * Builds the theme and group part of a copy price request.
 * Sends string IDs only. A filter mode is set only for a non-empty selection.
 */
export const buildThemeGroupFilters = (
  themes: DefaultOptionType[],
  groups: DefaultOptionType[],
): ThemeGroupFilters => ({
  themeIdsAsString:
    themes.length > 0 ? themes.map((theme) => theme.id) : undefined,
  themeFilterMode: themes.length > 0 ? FilterMode.Include : undefined,
  groupIdsAsString:
    groups.length > 0 ? groups.map((group) => group.id) : undefined,
  groupFilterMode: groups.length > 0 ? FilterMode.Include : undefined,
});
